// DS: CO0.1M
import React from 'react';
import { useTranslation } from 'react-i18next';
import classnames from 'classnames';
import HiddenIcon from '@wix/da-ds/pkg/Icons/32x32/Hidden';
import { IconSize } from '@wix/da-ds/pkg/Icons/IconWrap';
import { getIsStash } from '../../types/deviation/getters';
import PublishedTime from '../_partials/PublishedTime';
import WatchButton from './WatchButton';
import MoneyPromoButton from './MoneyPromoButton';
import BackButton from './BackButton';
import RootLayout from './RootLayout';
import UserInfoBlock from './UserInfoBlock';
import BackToStashButton from '../../ArtStage/_partials/BackToStashButton';
import s from './MobileSubmissionDetailsHeader.scss';
const MobileSubmissionDetailsHeader = ({ currentItem, isOwner, parent, isSticky = true, isStuck })=>{
    var _currentItem_extended;
    const { t } = useTranslation();
    const publishedTime = currentItem === null || currentItem === void 0 ? void 0 : currentItem.publishedTime;
    // Explicit check against false since this is mounted before a deviation finishes loading and
    // isPublished would be undefined then
    const isStashItem = (currentItem === null || currentItem === void 0 ? void 0 : currentItem.isPublished) === false;
    let moneyPromo = isStashItem ? undefined : currentItem === null || currentItem === void 0 ? void 0 : (_currentItem_extended = currentItem.extended) === null || _currentItem_extended === void 0 ? void 0 : _currentItem_extended.showStageMonetizationPromo;
    const author = currentItem === null || currentItem === void 0 ? void 0 : currentItem.author;
    // If this is an adoptable that's on sale or has sold, we need to remove
    // the monetization promo components. We'll do that by setting `moneyPromo` to undefined
    if ((currentItem === null || currentItem === void 0 ? void 0 : currentItem.isAdoptable) && (!currentItem.adoptable || [
        'onsale',
        'sold',
        'pending'
    ].includes(currentItem.adoptable.status))) {
        moneyPromo = undefined;
    }
    return /*#__PURE__*/ React.createElement(RootLayout, {
        className: classnames(s['root'], isSticky && s['sticky'], isStuck && s['stuck'], moneyPromo && s['money-promo'], // Explicit check since isPublished could be undefined.
        isStashItem && s['stash-header']),
        prefix: isStashItem ? /*#__PURE__*/ React.createElement(BackToStashButton, null) : parent && /*#__PURE__*/ React.createElement(BackButton, null),
        left: /*#__PURE__*/ React.createElement(React.Fragment, null, author && /*#__PURE__*/ React.createElement(UserInfoBlock, {
            user: author,
            publishedTime: publishedTime
        }), !author && publishedTime && /*#__PURE__*/ React.createElement(PublishedTime, {
            isStash: getIsStash(currentItem),
            publishedTime: publishedTime,
            withoutText: true
        })),
        right: /*#__PURE__*/ React.createElement(React.Fragment, null, moneyPromo && author && /*#__PURE__*/ React.createElement(MoneyPromoButton, {
            moneyPromo: moneyPromo,
            user: author,
            relevantDeviation: currentItem
        }), !moneyPromo && !isOwner && !isStashItem && author && /*#__PURE__*/ React.createElement(WatchButton, {
            user: author
        }), isStashItem && /*#__PURE__*/ React.createElement("span", {
            className: s['stash-right-text']
        }, /*#__PURE__*/ React.createElement(HiddenIcon, {
            size: IconSize.MEDIUM,
            disableDefaultColors: true,
            "aria-hidden": "true"
        }), t('mobileDeviationHeader.draftView')))
    });
};
MobileSubmissionDetailsHeader.displayName = 'MobileSubmissionDetailsHeader';
export default MobileSubmissionDetailsHeader;
